import { render } from "./collegeform.vue?vue&type=template&id=8c1f476a&ts=true"
import script from "./collegeform.vue?vue&type=script&lang=ts"
export * from "./collegeform.vue?vue&type=script&lang=ts"

import "./collegeform.vue?vue&type=style&index=0&id=8c1f476a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__